import { render, staticRenderFns } from "./myPurchasesMobile.vue?vue&type=template&id=c18e458e&scoped=true&lang=html&"
import script from "./myPurchasesMobile.vue?vue&type=script&lang=js&"
export * from "./myPurchasesMobile.vue?vue&type=script&lang=js&"
import style0 from "./myPurchasesMobile.vue?vue&type=style&index=0&id=c18e458e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18e458e",
  null
  
)

export default component.exports